import * as React from 'react';
import S from './DownloadCard.styles';
import { SystemIcon, getSvgFromSystem } from '@helpers/systemIcons';
const DownloadCard = (props) => {
    return (React.createElement(S.Container, { href: props.url, download: true },
        React.createElement(S.ContentArea, null,
            React.createElement(S.Title, null, props.title),
            props.description && React.createElement(S.Description, null, props.description),
            React.createElement(S.IconHolder, null, getSvgFromSystem(SystemIcon.Download)))));
};
export default DownloadCard;
